/** @flow */
import * as React from 'react';
import moment from 'moment';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import PrintingCard from 'common/modules/printing/styles/PrintingCard';
import DashboardPrintingWeeklyMetricsCard from './DashboardPrintingWeeklyMetricsCard';
import { hourlyMetricsType } from '../domain/DashboardData';
import WeekMetricPrintingElement from './components/WeekMetricPrintingElement';
import type { WeeklyDashboardData } from '../domain/DashboardData';

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.metrics.smallMargin}px 0;
  height: 8%;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
`;

const Content = styled.div`
  margin-top: 0px;
`;

const WeekMetricPrintingCard = styled(PrintingCard)`
  margin-top: ${({ theme }) => theme.metrics.margin}px;
`;


type Props = {
  data: ?WeeklyDashboardData,
  from: moment,
  to: moment,
  theme: any;
  t: any,
  type: hourlyMetricsType,
};

class WeeklyDashboardPrinting extends React.Component<Props> {
  render() {
    const { data, t, from, theme, type, to } = this.props;

    if (!data) {
      return null;
    }

    const overviewMetrics = {
      reach: data.averageReach,
      listeningTime: data.averageListeningTime,
      listeningTimePerPerson: data.averageListeningTimePerPerson,
    };
    return (
      <React.Fragment>
        <Header>
          <Title style={{ ...theme.fonts.style.secondary, fontWeight: 'bold' }}>
            {t('date.text', { value: moment(from) })} - {t('date.text', { value: moment(to) })}
          </Title>
        </Header>
        <Content>
          <DashboardPrintingWeeklyMetricsCard metrics={overviewMetrics} />
          <WeekMetricPrintingCard>
            <WeekMetricPrintingElement
              data={data}
              type={type}
            />
          </WeekMetricPrintingCard>
        </Content>
      </React.Fragment>
    );
  }
}

export default withTheme(translate()(WeeklyDashboardPrinting));



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/printing/WeeklyDashboardPrinting.js